module.exports = __webpack_public_path__ + "img/2_1-commerciale-cinema-1.8be5687e.png";